import React from 'react';
import css from './style.scss';
import cn from 'classnames'
import store from 'utils/store'
import {push} from 'react-router-redux'
import { Easing, Tween, autoPlay } from 'es6-tween'
import LazyLoad from 'react-lazyload'
autoPlay(true); // simplify the your code


const nextURL=(id)=>{
  let b=window.location.pathname.split('/')
  //console.log("NEXTURL", b)
  b.pop()
  b.push(id)
  return b.join('/')
}
class MiniStory extends React.Component{
  handleClick=()=>{
    store.dispatch(push(nextURL(this.props.id)))
//    store.dispatch(push("/a/"+this.props.account+"/"+this.props.id))
  }
  render(){
    let style={"backgroundImage":"url('"+this.props.thumb+"')"}
    return (
      <LazyLoad height={75} offset={100}>
      <div onClick={this.handleClick} style={style} className={cn(css.miniStory, this.props.selected ? css.selected : "")}></div>
      </LazyLoad>
    )
  }
}

class MiniStories extends React.Component{
  scrollToStory(props){
    let s=props.stories.slice().reverse()
    let index=s.findIndex(story=>props.selected===story.id)
    let coords = { x: this.refs.scroll.scrollLeft };
    if(this.refs.scroll){
      new Tween(coords)
      	.to({ x: 44*index-100}, 400)
        .easing(Easing.Quadratic.InOut)
      	.on('update', ({x}) => {
          if(this.refs.scroll){
            this.refs.scroll.scrollLeft=x;
          }
        })
      	.start();
    }
  }
  componentDidMount(){
    this.scrollToStory(this.props)
  }
  componentWillReceiveProps(props){
    this.scrollToStory(props)
  }
  render(){
    return(
      <div className={css.mainContainer}>
        <div ref="scroll" className={css.miniStoriesContainer}>
          {this.props.stories.slice().reverse().map(story=><MiniStory selected={this.props.selected===story.id} key={story.id} {...story}/>)}
          <div className={css.spacer}/>
        </div>
      </div>
    )
  }
}


export default MiniStories;



// WEBPACK FOOTER //
// ./src/components/account_page/story_details/miniStories/index.js